export default __webpack_public_path__ + "static/pawi-veteriner-yazilimi-f2cbb17928f4948bb4ae537536c2585e.png";